export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[500px] md:min-h-[620px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5 whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              <span>每日更新 · 全网最快</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              极速影视
              <span className="block text-primary-500 mt-1">最新电影电视剧免费在线观看</span>
            </h1>

            <p className="text-foreground-500 text-base md:text-lg leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              追剧不等待，高清不缓冲
            </p>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              极速影视为您汇集全网最新上映电影、热播电视剧全集与高清综艺节目单，覆盖动作、悬疑、爱情、喜剧等全品类内容。影视库每日更新，实时同步院线与平台首播资源，让您随时随地畅享流畅在线追剧体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-foreground-600">
                <span className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-movie-line text-primary-500 text-sm"></i>
                </span>
                <span className="text-sm font-medium whitespace-nowrap">每日更新 50+ 部</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-600">
                <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-tv-line text-accent-500 text-sm"></i>
                </span>
                <span className="text-sm font-medium whitespace-nowrap">全品类覆盖</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-600">
                <span className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-secondary-500 text-sm"></i>
                </span>
                <span className="text-sm font-medium whitespace-nowrap">高清流畅不卡顿</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleScrollTo(e, '#index')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即浏览专题
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScrollTo(e, '#ranking')}
                className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 rounded-lg font-medium text-sm cursor-pointer hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-bar-chart-line text-lg"></i>
                查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-primary-100/60 rounded-2xl -rotate-12"></div>
              <div className="absolute -bottom-4 -right-4 w-20 h-20 bg-accent-100/60 rounded-2xl rotate-12"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20lighting%2C%20film%20reels%2C%20popcorn%2C%20theater%20curtains%20in%20deep%20red%2C%20golden%20accents%2C%20vintage%20cinema%20aesthetic%2C%20artistic%20composition%20with%20soft%20shadows%2C%20warm%20amber%20and%20crimson%20tones%2C%20elegant%20film%20poster%20collage%20style%2C%20no%20text%2C%20abstract%20cinematic%20elements&width=800&height=600&seq=hero-movie-2026-01&orientation=landscape"
                alt="极速影视 - 最新电影电视剧免费在线观看平台"
                className="w-full h-auto rounded-2xl object-cover shadow-sm"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}